<div class="mobile-header {{page == 'homepage'?'homepage-header':''}}" [ngClass]="{'mobile-header--sticky': stickyMode}"
    #element>
    <div class="mobile-header__panel" #panelElement>
        <div class="container">
            <div class="mobile-header__body">
                <button class="mobile-header__menu-button" (click)="menu.open()">
                    <app-icon name="menu-18x14" size="18x14"></app-icon>
                </button>
                <a class="mobile-header__logo" routerLink="/">
                    <img style="width: auto; height: 46px;" [src]="siteService.siteSetting?.logo?.url || 'assets/svg/logo-main.svg'">
                </a>

                <app-search appDropdown="mobile-header__search--open" class="mobile-header__search"
                    location="mobile-header" #search="search" #searchDropdown="appDropdown"
                    [searchDropdown]="searchDropdown">
                </app-search>

                <div class="mobile-header__indicators">

                    <div class="indicator indicator--mobile">
                        <div class="topbar__item">
                            <div class="topbar-dropdown" appDropdown="topbar-dropdown--opened"
                                #languageDropdown="appDropdown">
                                <button type="button" class="mt-1 border-none"
                                    (click)="countries.length > 1? languageDropdown.toggle() :changeCountry(countries[0], languageDropdown)">
                                     <img *ngIf="currentCountry?.code =='BHR' || currentCountry?.code == 'KSA'"
                                        width="28" [src]="'assets/images/flags/'+currentCountry?.code+'.png'">
                                </button>
                                <div class="topbar-dropdown__body mx-5 z-50">

                                    <div class="menu menu--layout--topbar menu--with-icons">

                                        <ul class="menu__list">
                                            <li class="menu__item" *ngFor="let country of countries"
                                                (mouseover)="menuItem.classList.add('menu__item--hover')"
                                                (mouseleave)="menuItem.classList.remove('menu__item--hover')" #menuItem>
                                                <button class="menu__item-link" type="button"
                                                    (click)="changeCountry(country, languageDropdown)">
                                                    <span class="menu__item-icon">
                                                        <img *ngIf="country.code =='BHR' || country.code == 'KSA'"
                                                            width="28"
                                                            [src]="'assets/images/flags/'+country.code+'.png'">
                                                    </span>
                                                    {{ translateHelper.localize(country.name) }}
                                                    <span
                                                        *ngIf="currentCountry?._id == country?._id && selectedZone?.city?.name">-{{
                                                        translateHelper.localize(selectedZone?.city?.name)}}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <app-indicator [icon]="translateService.currentLang == 'ar'? 'en2ar' : 'ar2en'" size="37"
                            [title]="translateService.currentLang == 'ar'? 'English' : 'العربية'" trigger="click"
                            (buttonClick)="translateService.currentLang == 'ar'? changeLangage('en'): changeLangage('ar')">
                        </app-indicator>
                        <!-- <app-indicator link="./shop/cart" icon="cart-20" trigger="click"
                            [counter]="cart.quantity$|async" (buttonClick)="onCartClick()" #indicator="appIndicator">
                            <app-header-dropcart *ngIf="dropcartType == 'dropdown'" (closeMenu)="indicator.close(true)">
                            </app-header-dropcart>
                        </app-indicator>
                        <app-indicator
                            routerLink="./quotation-cart"
                            icon="quotation-20"
                            title="Quotations"
                            trigger="click"
                            [counter]="quotationCart.quantity$|async"
                            #indicator3="appIndicator"
                        >
                        </app-indicator> -->

                        <app-indicator *ngIf="!userDetails" icon="person-20" [title]="'login'|translate" link="/login">
                        </app-indicator>
                        <!-- <app-indicator
                            *ngIf="userDetails"
                            icon="person-20"
                            [title]="'logout'|translate"
                            trigger="click"
                            (buttonClick)="logout()"
                        >
                        </app-indicator> -->

                        <app-indicator *ngIf="userDetails" link="./account" icon="person-20" trigger="click"
                            title="Account" #indicator1="appIndicator">
                            <app-account-menu (closeMenu)="indicator1.close(false)"></app-account-menu>
                        </app-indicator>
                        <!-- <app-menu-items *ngIf="!userDetails" [name]="'login'|translate" [url]="'/login'" (itemClick)="onItemClick($event)"></app-menu-items>
                        <div *ngIf="userDetails">

                            <app-menu-items [name]="'logout'|translate" [url]="''" (itemClick)="onItemClick($event)" (click)="logout()">
                            </app-menu-items>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <app-header-topbar></app-header-topbar>
        <app-categories-underbar></app-categories-underbar>
    </div>
</div>